import { BasicEvent } from "./BasicEvent";

export class ArbetsorderHandelssortimentAddedEventMessage extends BasicEvent {
    arbetsorderId: number;
    arbetsorderHandelssortimentId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderHandelssortimentAddedEventMessage";
    constructor($type: string) {
        super($type);
    }
}
